import { Clock, ShieldCheck, Zap, Phone } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "../constants";
import { WhatsAppIcon } from "./Logo";

export const ProntoIntervento = ({ asH1 = false }) => {
  const Heading = asH1 ? "h1" : "h2";
  return (
  <section
    id="pronto-intervento"
    data-testid="pronto-intervento-section"
    className="py-24 md:py-32 relative overflow-hidden"
  >
    <div className="absolute inset-0 bg-gradient-to-b from-[#FF6B00]/[0.07] to-transparent pointer-events-none" />
    <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative">
      <FadeUp>
        <Eyebrow>Pronto intervento</Eyebrow>
        <Heading className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4">
          Un guasto oggi?
          <span className="text-[#FF6B00]"> Lo risolviamo oggi.</span>
        </Heading>
        <p className="mt-6 max-w-lg text-base md:text-lg text-[#94A3B8]">
          Caldaia in blocco, condizionatore fermo, perdite: per il pronto
          intervento risolviamo in giornata qualunque problema, in tutta Roma e
          provincia.
        </p>
        <ul className="mt-8 space-y-4">
          {[
            { icon: Clock, text: "Tecnico a casa tua in giornata, anche il sabato e la domenica" },
            { icon: ShieldCheck, text: "Il diritto di chiamata è fisso: 50€, nessuna sorpresa" },
            { icon: Zap, text: "Chiami o scrivi su WhatsApp e il tecnico parte subito" },
          ].map((f, i) => (
            <li key={i} className="flex items-start gap-4" data-testid={`pronto-intervento-point-${i}`}>
              <f.icon className="w-5 h-5 text-[#FF6B00] mt-0.5 shrink-0" />
              <span className="text-[#F1F5F9] text-sm md:text-base">{f.text}</span>
            </li>
          ))}
        </ul>
      </FadeUp>

      <FadeUp delay={0.15}>
        <div className="glass rounded-3xl p-8 md:p-10">
          <div className="flex items-end justify-between mb-8">
            <div>
              <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#94A3B8]">
                Diritto di chiamata
              </p>
              <p className="font-display font-semibold text-6xl tracking-tighter mt-2" data-testid="prezzo-diritto-chiamata">
                50€
              </p>
            </div>
            <p className="text-xs text-[#94A3B8] text-right max-w-[140px]">
              Il costo della riparazione viene concordato sul posto
            </p>
          </div>
          <p className="text-sm text-[#94A3B8] mb-6">
            Prenota ora il pronto intervento: ti rispondiamo subito e fissiamo
            l'uscita del tecnico per oggi.
          </p>
          <div className="flex flex-col gap-3">
            <a
              href={PHONE_TEL}
              data-testid="pronto-intervento-phone"
              className="flex items-center justify-center gap-2 rounded-full bg-[#FF6B00] text-[#07090D] px-6 py-4 text-sm font-semibold uppercase tracking-wider transition-all duration-300 hover:shadow-[0_0_40px_rgba(255,107,0,0.45)] active:scale-[0.98]"
            >
              <Phone className="w-4 h-4" /> Chiama {PHONE_DISPLAY}
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="pronto-intervento-whatsapp"
              className="flex items-center justify-center gap-2 rounded-full border border-white/20 px-6 py-4 text-sm font-semibold uppercase tracking-wider transition-all duration-300 hover:border-[#25D366] hover:text-[#25D366] active:scale-[0.98]"
            >
              <WhatsAppIcon className="w-4 h-4" /> Scrivi su WhatsApp
            </a>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
  );
};
